import { Link } from 'foundations-components/transitional/components/Link';
import { Flex } from 'foundations-components/components/Flex';
import useGetSocialProfileProperties from './data/useGetSocialProfileProperties';
import { capitalizeNetwork, ensureProtocol, isLIPersonURN, safeConvertTwitterLabel } from './utils/utils';
import { SocialFacebookIcon, SocialInstagramIcon, SocialLinkedinIcon, SocialXIcon, SocialYoutubeIcon } from 'foundations-assets';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PROFILE_CARD_PROPERTIES = ['hs_network', 'hs_profile_url', 'hs_username', 'hs_profile_key'];
const networkIconMap = {
  Facebook: SocialFacebookIcon,
  X: SocialXIcon,
  Instagram: SocialInstagramIcon,
  Linkedin: SocialLinkedinIcon,
  Youtube: SocialYoutubeIcon
};
const checkIfNotLIPersonURN = username => {
  return username && !isLIPersonURN(username) ? username : null;
};
const SocialProfileChickletPrimaryDisplayLabel = ({
  toObjectId,
  primaryDisplayProperty
}) => {
  const properties = useGetSocialProfileProperties(toObjectId, PROFILE_CARD_PROPERTIES);
  if (!properties.hs_network) {
    return null;
  }
  const network = safeConvertTwitterLabel(capitalizeNetwork(properties.hs_network));
  const icon = networkIconMap[network];
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "200",
    children: [network && /*#__PURE__*/_jsx(IconCircle, {
      icon: icon,
      color: "text-core-on-fill-default",
      borderWidth: "0",
      backgroundColor: `do-not-use-${network.toLowerCase()}`,
      size: "100",
      padding: "25",
      verticalAlign: 'center',
      "data-selenium-test": `social-icon-${properties.hs_network}`,
      "data-test-id": `social-icon-${properties.hs_network}`
    }), properties.hs_profile_url ? /*#__PURE__*/_jsx(Link, {
      href: ensureProtocol(properties.hs_profile_url),
      external: true,
      children: (primaryDisplayProperty === null || primaryDisplayProperty === void 0 ? void 0 : primaryDisplayProperty.value) || checkIfNotLIPersonURN(properties.hs_username) || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.networkUserLabel",
        options: {
          network
        }
      })
    }) : (primaryDisplayProperty === null || primaryDisplayProperty === void 0 ? void 0 : primaryDisplayProperty.value) || checkIfNotLIPersonURN(properties.hs_username) || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardAssociatedObjects.networkUserLabel",
      options: {
        network
      }
    })]
  });
};
export default SocialProfileChickletPrimaryDisplayLabel;